// extracted by mini-css-extract-plugin
module.exports = {"paginateArea":"Pagination_paginateArea__C9jia","paginate":"Pagination_paginate__2Gnqs","current":"Pagination_current__3AzfN"};